import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'react-feather';
import { items } from './data';
import { Item } from './types';
import { useGeneralContext } from '../../context';

const Carousel = () => {
  const [index, setIndex] = useState(0);
  let startX = 0;
  let endX = 0;

  const next = () => {
    if (index === items.length - 1) {
      setIndex(0);
      return;
    }
    setIndex(index + 1);
  };
  const previous = () => {
    if (index === 0) {
      setIndex(items.length - 1);
      return;
    }
    setIndex(index - 1);
  };

  const handleTouchStart = (e: any) => {
    startX = e.touches[0].clientX;
  };

  const handleTouchMove = (e: any) => {
    endX = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const diff = startX - endX;
    if (diff > 50) {
      next();
    } else if (diff < -50) {
      previous();
    }
  };

  return (
    <>
      <div
        className="tw-w-full tw-max-w-3xl tw-overflow-hidden"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className="tw-flex tw-flex-row tw-flex-nowrap tw-items-stretch"
          style={{
            transform: `translateX(${-index * 100}%)`,
            transition: 'transform 750ms cubic-bezier(0.39, 0.575, 0.565, 1)'
          }}
        >
          {items.map((item, i) => (
            <CarouselItem key={i} item={item} />
          ))}
        </div>
      </div>
      <div className="tw-w-full tw-flex tw-flex-row tw-justify-center tw-items-center tw-gap-2 lg:tw-gap-6 tw-font-bold tw-text-base lg:tw-text-lg tw-mt-4 tw-px-2">
        <button className="tw-bg-transparent tw-border-none tw-p-1" onClick={previous}>
          <ChevronLeft size={24} className="lg:tw-w-9 lg:tw-h-9 tw-w-6 tw-h-6" />
        </button>
        {items.map((_, i) => (
          <button
            key={`dot-${i}`}
            className={`tw-min-w-[12px] tw-min-h-[12px] lg:tw-min-w-[16px] lg:tw-min-h-[16px] tw-aspect-square tw-rounded-full tw-border-none ${
              i === index ? 'tw-bg-neutral-800' : 'tw-bg-neutral-300'
            }`}
            onClick={() => setIndex(i)}
          ></button>
        ))}
        <button className="tw-bg-transparent tw-border-none tw-p-1" onClick={next}>
          <ChevronRight size={24} className="lg:tw-w-9 lg:tw-h-9 tw-w-6 tw-h-6" />
        </button>
      </div>
    </>
  );
};

const CarouselItem = (props: { item: Item }) => {
  const { title, data, date, icon, role, location, cta, centeredContent } = props.item;

  const { setFeedbackModalOpen } = useGeneralContext();

  return (
    // A slide is one full viewport wide and must not shrink: without tw-shrink-0
    // the flex row divides the available width between every slide instead.
    <div className="tw-w-full tw-shrink-0 tw-px-2 tw-py-3">
      <div className="tw-rounded-2xl tw-bg-white tw-justify-center tw-items-center tw-shadow-lg tw-grid tw-h-full tw-p-6 lg:tw-p-10 tw-gap-4 lg:tw-grid-cols-[auto_minmax(0,1fr)] lg:tw-gap-8">
        <div className="tw-w-32 tw-h-32 lg:tw-w-44 lg:tw-h-44 tw-justify-self-center lg:tw-justify-self-start">
          {icon || <></>}
        </div>
        <div
          className={`tw-h-full tw-flex tw-flex-col tw-justify-center tw-gap-3 ${
            centeredContent ? 'tw-items-center' : 'tw-items-start'
          }`}
        >
          <div className="tw-flex tw-flex-col tw-w-full tw-gap-1">
            <div className="tw-text-neutral-800 tw-font-semibold tw-text-lg lg:tw-text-xl">{title}</div>
            {role && <div className="tw-text-neutral-500 tw-text-xs">{role}</div>}
          </div>
          {cta && (
            <button
              className="tw-flex tw-px-6 tw-min-h-control tw-justify-center tw-items-center tw-gap-2 tw-rounded-lg tw-bg-primary-500 tw-border-2 tw-border-primary-500 tw-text-white tw-font-semibold tw-text-base tw-self-start"
              onClick={() => {
                setFeedbackModalOpen(true);
              }}
            >
              Share your Story!
            </button>
          )}
          <div className="tw-text-neutral-800 tw-text-sm lg:tw-text-base tw-self-start">{data}</div>
          {(location || date) && (
            <div className="tw-flex tw-flex-col tw-items-start tw-gap-0.5 tw-mb-1">
              {location && <div className="tw-text-neutral-500 tw-text-xs">{location}</div>}
              <div className="tw-text-neutral-500 tw-text-xs">{date}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
